// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"button-wrapper_wrapper__1ySnw","reverse":"button-wrapper_reverse__PvIWW"};